import { LocalService } from './../../../services/storage/localService';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from 'app/services/login/login.service';
import { FacturacionCPEService } from 'app/services/facturacion-cpe/facturacion-cpe.service';
import { Router } from '@angular/router';
import { Component, OnInit, Injector } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MatTableDataSource, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import Swal from "sweetalert2";
import { MessagesTitles, MessagesStatus } from 'app/models/messages';
import { DetalleFactura } from 'app/models/DetalleFacturaCPE.model';
import { DeudasService } from 'app/services/cobranzas/deudas/deudas.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-cpe-nota-debito',
  templateUrl: './cpe-nota-debito.component.html',
  styleUrls: ['./cpe-nota-debito.component.scss'],
  providers: [MessagesTitles, MessagesStatus, DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class CpeNotaDebitoComponent implements OnInit {
  Id_IGV_Exonerado = environment.ID_IGV_Exonerado;
  Id_IGV_No_Exonerado = environment.ID_IGV_No_Exonerado;
  IGV_Porcentaje: any = 0;
  Codigo_Tributo: any = 0;
  IGV_Afectacion: any = 0
  minDate = moment().add(-7, 'day');
  maxChars = 140;
  tipoOperacionNDElement = 128;

  form: FormGroup;
  monedaElement: any;
  now = moment();
  dataSource1 = new MatTableDataSource();
  precioU: number = 0;
  tipoDocumentoElement: any;

  SubTotal: number = 0;
  Igv: number = 0;
  Total: number = 0;
  xd: number = 0;
  dataFactura: any;
  dataDetail: DetalleFactura[] = [];
  abrirDetalle: boolean = false;
  abrirDetalle2: boolean = false;
  CPETemporal: any = {}
  arrayCorrelativo: any = [];

  gravada: number = 0;
  noGravada: number = 0;

  displayedColumns1 = ['Item', 'Codigo', 'Cantidad', 'Unidad', 'Descripcion', 'Valor_Unitario', 'Precio_Unitario', 'Importe_Total', 'Accion'];
  serviceCPE: FacturacionCPEService;
  loginService: LoginService;
  localService: LocalService;
  deudaService: DeudasService;
  cpeService: FacturacionCPEService;
  constructor(private injector: Injector,
    private datepipe: DatePipe,
    private router: Router,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {
    this.serviceCPE = this.injector.get<FacturacionCPEService>(FacturacionCPEService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.deudaService = this.injector.get<DeudasService>(DeudasService);
    this.cpeService = this.injector.get<FacturacionCPEService>(FacturacionCPEService);
    if (this.serviceCPE.TipoCambio != undefined) {
      this.loginService.clickGuard = false;
    } else {
      this.loginService.clickGuard = true;
      this.router.navigate(['/facturacion/notaDebito/listado']);
    }

    this.form = new FormGroup({
      Tipo_Comprobante: new FormControl({ value: 'F', disabled: false }, [Validators.required]),
      Serie_Referente: new FormControl({ value: 'F002', disabled: false }, [Validators.required]),
      Serie: new FormControl({ value: 'F002', disabled: false }, [Validators.required]),
      Numero_Referente: new FormControl({ value: '', disabled: false }, []),
      Tipo_Operacion: new FormControl({ value: 128, disabled: false }, [Validators.required]),
      Fecha_Referente: new FormControl('', []),
      Observacion: new FormControl('', [Validators.required]),

      Tipo_Documento: new FormControl({ value: '', disabled: true }, [Validators.required]),
      Moneda: new FormControl({ value: '', disabled: true }, [Validators.required]),
      Razon_Social: new FormControl({ value: '', disabled: true }, [Validators.required]),
      Direccion_Fiscal: new FormControl({ value: '', disabled: true }, [Validators.required]),

      IGV: new FormControl({ value: this.IGV_Porcentaje, disabled: true }, [Validators.required]),
      Fecha_Emision: new FormControl(this.now, [Validators.required]),
      Numero: new FormControl('', []),
      Correo: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.obtenerCorrelativo();
    this.obtenerProductos();
  }
  obtenerNumero(serie: any) {
    for (let item of this.arrayCorrelativo.data) {
      if (serie == item.Serie) {
        let corre = Number(item.Numero) + 1
        this.form.controls['Numero'].setValue(corre)
      }
    }
  }

  obtenerCorrelativo() {
    let Tipo_Comprobante = 'D'
    this.serviceCPE.ObtenerNumeracion(Tipo_Comprobante).subscribe(
      res => {
        this.arrayCorrelativo = res
        let ser = this.form.controls['Serie_Referente'].value
        this.obtenerNumero(ser);
      }, err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    )
  }


  tipoOperacionND(event) {
    this.form.controls['Tipo_Operacion'].setValue(event);
  }

  tipoDocumento(event) {
    this.form.controls['Tipo_Documento'].setValue(event);
  }
  tipoMoneda(event) {
    this.form.controls['TipoCambio'].setValue(event);
  }

  Generar() {
    for (let item of this.dataDetail) {
      item.Valor_Venta = Math.round((item.Valor_Unitario * (1 + Number(item.IGV_Porcentaje))) * 100) / 100;
      item.IGV_Importe = Math.round(((item.Cantidad * item.Valor_Unitario) * item.IGV_Porcentaje) * 100) / 100;
      item.Precio_Venta = Math.round((item.Valor_Venta * item.Cantidad) * 100) / 100;
    }


    this.CPETemporal.Detalle = [];
    this.CPETemporal.idComprobanteIFRef = this.dataFactura.idComprobanteIF;
    this.CPETemporal.idLocal = 1;
    this.CPETemporal.Tipo_Operacion = this.form.controls['Tipo_Operacion'].value;
    this.CPETemporal.Tipo_Pago = 114;
    this.CPETemporal.Tipo_Comprobante = "D";
    this.CPETemporal.Observacion = this.form.controls['Observacion'].value;
    this.CPETemporal.Serie = this.form.controls['Serie'].value;
    this.CPETemporal.Fecha_Emision = this.datepipe.transform(this.form.controls['Fecha_Emision'].value, 'yyyy-MM-dd');
    this.CPETemporal.Fecha_Vencimiento = this.datepipe.transform(this.form.controls['Fecha_Emision'].value, 'yyyy-MM-dd');
    this.CPETemporal.Moneda = this.dataFactura.Moneda;
    this.CPETemporal.Valor_Venta = this.SubTotal;
    this.CPETemporal.idCliente = this.dataFactura.idEmpresa;
    this.CPETemporal.Correo = this.form.controls['Correo'].value;
    this.CPETemporal.IGV_Exonerado = this.Id_IGV_No_Exonerado;
    this.CPETemporal.IGV_Porcentaje = this.IGV_Porcentaje;
    this.CPETemporal.IGV_Importe = this.Igv;
    this.CPETemporal.Precio_Venta = this.Total;
    this.CPETemporal.Operaciones_Grabadas = this.gravada;
    this.CPETemporal.Operaciones_Inafectas = this.noGravada;

    for (const item of this.dataDetail) {
      this.CPETemporal.Detalle.push(item)
    }

    Swal.fire({
      title: "Espere...",
      text: "Guardando la información.",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.serviceCPE.GuardarCPENotaD(this.CPETemporal)
      .subscribe(resp => {
        Swal.fire({
          title: "¡Éxito!",
          text: "CPE guardado correctamente.",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(res => {
          if (res.value == true) {
            this.loginService.clickGuard = true;
            this.router.navigate(['/facturacion/notaDebito/listado']);
          }
        });
      }, (err: HttpErrorResponse) => {

        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "CPE NO GUARDADO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });
  }

  AddItem() {
    this.abrirDetalle2 = true
  }

  CerrarDetalle2() {
    this.abrirDetalle2 = false;
  }

  public calculateTotal() {
    this.SubTotal = 0;
    this.Igv = 0;
    this.Total = 0;
    this.noGravada = 0;
    this.gravada = 0;
    for (let item of this.dataDetail) {
      this.SubTotal += item.Cantidad * item.Valor_Unitario;
      this.Igv += (item.Cantidad * item.Valor_Unitario) * item.IGV_Porcentaje;
      this.Total += this.CalcularPrecioTotal(item.Cantidad, item.Valor_Unitario, item.IGV_Porcentaje);
      if (item.IGV_Porcentaje == "0.00") {
        this.noGravada += item.Cantidad * item.Valor_Unitario;
      } else {
        this.gravada += (item.Cantidad * item.Valor_Unitario) * (1 + Number(item.IGV_Porcentaje));
      }
    }
  }

  CalcularPrecioUnitario(valorUnitario: any, IGV_Porcentaje: any): number {
    this.precioU = Math.round((valorUnitario * (1 + Number(IGV_Porcentaje))) * 100) / 100;
    return this.precioU;
  }

  CalcularPrecioTotal(cantidad: any, valorUnitario: any, IGV_Porcentaje: any): number {
    let valor = (cantidad * valorUnitario)
    this.precioU = Math.round((valor * IGV_Porcentaje + valor) * 100) / 100;
    return this.precioU;
  }

  createNewrow() {
    return {
      "Codigo_Producto": "01",
      "Cantidad": 1,
      "Descripcion": "INTERES DESCUENTO",
      "Unidad_Medida": "NIU",
      "Valor_Unitario": 1,
      "idSolicitudD_Detalle": '',
      "idOperacion": '',
    };
  }


  Eliminar(index: number, IGV_Porcentaje: string, total: number) {
    if (this.dataSource1.data.length == 1) {
      Swal.fire({
        title: 'No se puede dejar un registro vacio',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }
    if (IGV_Porcentaje == "0.00") {
      this.noGravada = this.noGravada - total;
    }
    this.dataSource1.data.splice(index, 1);
    this.dataSource1._updateChangeSubscription();
    this.calculateTotal();
  }

  CerrarDetalle() {
    this.abrirDetalle = false;
  }
  RecibirDataFactura() {
    this.dataFactura = this.serviceCPE.dataFactura;
    this.dataDetail = this.dataFactura.detail
    this.dataSource1 = new MatTableDataSource(this.dataDetail);
    this.calculateTotal();
    this.monedaElement = this.dataFactura.Moneda;
    this.tipoDocumentoElement = this.dataFactura.Tipo_Doc_Identificacion;
    this.form.controls['Razon_Social'].setValue(this.dataFactura.Razon_Social);
    this.form.controls['Direccion_Fiscal'].setValue(this.dataFactura.Direccion_Fiscal);
    this.form.controls['Correo'].setValue(this.dataFactura.Correo);
  }

  onClick() {
    if (this.form.controls['Numero_Referente'].value == '' && this.form.controls['Fecha_Referente'].value == '') {
      Swal.fire({
        title: '¡¡Advertencia!',
        text: 'Ingrese Numero Referente ó Fecha Referente',
        type: 'info',
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    this.form.controls['Tipo_Comprobante'].setValue('F');
    this.serviceCPE.DataBuscar = this.form.value;
    this.abrirDetalle = true;
  }


  RecibirDetalle(event) {
    this.dataSource1.data.push(event)
    this.dataSource1._updateChangeSubscription();
    this.calculateTotal();
    // this.calculateTotal(); 
  }

  obtenerProductos() {
    this.deudaService.obtenerProductos().subscribe(res => {
      this.cpeService.Productos = res
    })
  }

}



